export default __webpack_public_path__ + "9b41944fb8d7a1d2a33fe75db8996b7a.svg";